var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1259_2671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM20.1336 15.7776C20.0976 15.8518 20.0469 15.9179 19.9845 15.9718C19.9222 16.0257 19.8495 16.0664 19.7709 16.0913C19.6923 16.1163 19.6094 16.1249 19.5274 16.1168C19.4453 16.1087 19.3658 16.0839 19.2936 16.044L12.3072 12.1608C12.2139 12.1084 12.1363 12.032 12.0823 11.9397C12.0283 11.8473 11.9999 11.7422 12 11.6352V3.6C12.0008 3.51785 12.0184 3.43672 12.0516 3.36157C12.0848 3.28642 12.1329 3.21882 12.1931 3.1629C12.2533 3.10698 12.3242 3.06391 12.4016 3.03631C12.479 3.00872 12.5612 2.99718 12.6432 3.0024C14.9174 3.16517 17.0454 4.18415 18.598 5.8539C20.1506 7.52364 21.0124 9.71995 21.0096 12C21.0025 13.3087 20.7032 14.5993 20.1336 15.7776Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1259_2671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.a639484367cd8cab1a8521038bd224dd.svg";
export { ForwardRef as ReactComponent };